import { render } from "./TopicCircles.vue?vue&type=template&id=5a25c857&scoped=true"
import script from "./TopicCircles.vue?vue&type=script&lang=js"
export * from "./TopicCircles.vue?vue&type=script&lang=js"

import "./TopicCircles.vue?vue&type=style&index=0&id=5a25c857&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a25c857"]])

export default __exports__